import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout';
import Loader from '@Components/Loader';
import FindSimilarModalContent from './Components/FindSimilarModalContent';
import FindSimilarModalIntegratedDbsContent from './Components/FindSimilarModalIntegratedDbsContent';

import './FindSimilarModal.custom.scss';
import './FindSimilarModal.theme.scss';

function FindSimilarModal(props) {
  const { data, itemsForDB, goTo, initialize, isLoading, close, modalTitle, isIntegratedModal, itemsForAvailableDB, itemsForCurrentDB } =
    props;

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <GeneralDialogLayout
      {...props}
      className="react-dialogs-scrollable find-similar-modal"
      size="xl"
      selfClose={close}
      header={
        <div className="find-similar-modal__header">
          <h4>{modalTitle}</h4>
        </div>
      }>
      {isLoading && (
        <div className="find-similar-modal__loader">
          <Loader startProgress={0} />
        </div>
      )}
      {isIntegratedModal ? (
        <FindSimilarModalIntegratedDbsContent
          data={data}
          goTo={goTo}
          itemsForCurrentDB={itemsForCurrentDB}
          itemsForAvailableDB={itemsForAvailableDB}
        />
      ) : (
        <FindSimilarModalContent data={data} itemsForDb={itemsForDB} goTo={goTo} />
      )}
    </GeneralDialogLayout>
  );
}

FindSimilarModal.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
  }),
  close: PropTypes.func.isRequired,
  goTo: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  itemsForDB: PropTypes.array,
  itemsForAvailableDB: PropTypes.array,
  itemsForCurrentDB: PropTypes.array,
  modalTitle: PropTypes.string,
  isIntegratedModal: PropTypes.bool,
};

export default FindSimilarModal;
